<template>
    <client-page>
        <section class="section">
            <v-container>
                <div class="section-title-wrap" >
                    <h2 class="client-title--xxxl">발간자료실</h2>
                </div>

                <!-- 발간자료실 상단 -->
                <div class="library-report">
                    <div class="library-report__inner">
                        <v-row v-if="board" align="center">
                            <v-spacer />
                            <v-col cols="5" lg="4">
                                <v-img :src="board.thumb" :aspect-ratio="1" class="border-radius-16" />
                            </v-col>
                            <v-col cols="7" lg="6">
                                <v-row class="row--sm white--text">
                                    <v-col cols="12">
                                        <h3 class="client-title--lg">{{ board.subject }}</h3>
                                    </v-col>
                                    <v-col cols="12">
                                        <p class="client-title--sm font-weight-regular">{{ board.summary }}</p>
                                    </v-col>
                                    <v-col cols="12">
                                        <v-sheet color="transparent" max-width="416" class="d-flex j">
                                            <v-row justify="spaceBetween" class="row--sm">
                                                <v-col cols="12" md="6">
                                                    <v-btn block rounded="pill" large :href="board.url" target="__blank">
                                                        <span class="primary--text">
                                                            온라인 연차보고
                                                            <v-icon small class="ml-10">mdi-chevron-right</v-icon>
                                                        </span>
                                                    </v-btn>
                                                </v-col>
                                                <v-col cols="12" md="6">
                                                    <v-btn block outlined color="white" rounded="pill" large @click="download(`${board?.files[0]?.url}`, `${board?.files[0]?.fileName}`)">
                                                        PDF 보기
                                                        <v-icon small class="ml-10">mdi-chevron-right</v-icon>
                                                    </v-btn>
                                                </v-col>
                                            </v-row>
                                        </v-sheet>
                                    </v-col>
                                </v-row>
                            </v-col>
                        </v-row>
                    </div>
                </div>

                <template v-if="!$route.params._board && $route.query.mode !== 'input'">
                    <board-list code="library" />
                </template>
                <board-write v-else-if="$route.query.mode === 'input'" />
                <board-view v-else />
            </v-container>
        </section>
    </client-page>
</template>

<script>
import api from "@/api";
import ClientPage from "@/pages/client/templates/ClientPage.vue";
import SubVisualBoard from "@/components/client/sub/sub-visual-borad.vue";
// import TabFair from "@/components/client/sub/tab-fair.vue";
import BoardView from "@/components/client/support/board-view.vue";
import BoardList from "@/components/client/support/board-list.vue";
import BoardWrite from "@/components/client/support/board-write.vue";

import NewsList from "@/components/client/support/news-list.vue";
import download from "downloadjs";

export default {
    components: {
        ClientPage,
        SubVisualBoard,
        // TabFair,
        BoardView,
        BoardList,
        BoardWrite,
        NewsList,
    },
    data() {
        return {
            tab: null,
            board: null
        };
    },
    mounted() {
        this.init();
    },
    methods: {
        async init() {
            api.v1.boards.gets({ headers: { limit: 1 }, params: { code: "library", isMain: "true" }}).then(res => this.board = res.boards[0]);
        },
        download(path, rename) {
            api.getResource(path).then((file) => download(file, rename));
        },
    },
    watch: {
        code() {},
    },
};
</script>

<style lang="scss" scoped>
.board-tabs {
    margin-bottom: 40px;
    ::v-deep(.v-slide-group__prev) {
        display: none;
    }
    .v-tab {
        background-color: #f5f5f5;
        &:first-of-type {
            border-top-left-radius: 999px;
            border-bottom-left-radius: 999px;
        }
        &:last-of-type {
            border-top-right-radius: 999px;
            border-bottom-right-radius: 999px;
        }
        &--active {
            background-color: var(--v-primary-base);
            color: #fff;
        }
    }
}
.library-report {
    padding: 40px 0;
    margin-bottom: 40px;
    position: relative;
    &::before {
        content: "";
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        width: 100vw;
        max-width: 1920px;
        height: 100%;
        background: rgb(100, 148, 67) url(/images/news/library.jpg) no-repeat center / cover;
    }
    &__inner {
        position: inherit;
        z-index: 1;
    }
}
@media (min-width: 768px) {
    .board-tabs {
        margin-bottom: 60px;
        ::v-deep(.v-tabs-bar),
        .v-tab {
            height: 60px;
        }
    }
    .library-report {
        padding: 86px 0;
        margin-bottom: 80px;
    }
}
</style>